import { render, staticRenderFns } from "./CamposDadosBasicos.vue?vue&type=template&id=a3f4917e&scoped=true"
import script from "./CamposDadosBasicos.vue?vue&type=script&lang=ts&setup=true"
export * from "./CamposDadosBasicos.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CamposDadosBasicos.vue?vue&type=style&index=0&id=a3f4917e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f4917e",
  null
  
)

export default component.exports